export const ADD_EXCHANGE = 'ADD_EXCHANGE';
export const GET_EXCHANGE = 'GET_EXCHANGE';
export const GET_EXCHANGE_BY_ID = 'GET_EXCHANGE_BY_ID';
export const GET_EXCHANGE_FORM_CONFIG = 'GET_EXCHANGE_FORM_CONFIG';
export const MODIFY_EDITING_EXCHANGE = 'MODIFY_EDITING_EXCHANGE';
export const RESET_EXCHANGE_FORM = 'RESET_EXCHANGE_FORM';
export const RESET_EXCHANGE_LIST = 'RESET_EXCHANGE_LIST';
export const SET_EXCHANGE_FILTERS = 'SET_EXCHANGE_FILTERS';
export const SET_EXCHANGE_PAGINATION = 'SET_EXCHANGE_PAGINATION';
export const UPDATE_EXCHANGE = 'UPDATE_EXCHANGE';



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/constants/exchange_constants.js